import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ConfirmationPage.css";
import BookCover from "../assets/The-Blueprint.png";
import { verifyPurchase } from "../api/verify-purchase";
import { setWithExpiry } from "../utils/sessionStorage";

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError("");

    setIsLoading(true);

    await verifyPurchase(email)
      .then((res) => {
        if (res) {
          setIsVerified(true);
          // sessionStorage
          setWithExpiry("pdfAccess", true);
          navigate("/blueprint-view-pdf");
        } else {
          setIsLoading(false);
          setError(
            "No purchase found for this email. Please make sure you've completed payment and are using the same email address."
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError(
          "An error occurred while verifying your purchase. Ensure you've completed payment and are using the same email address. Please try again."
        );
      });
  };

  const renderError = () => {
    if (!error) return null;

    return (
      <div className="error-container">
        <p>
          <span className="error-icon">⚠️</span>
          {error}
        </p>
      </div>
    );
  };

  return (
    <div className="confirmation-page">
      <h1>Access Your PDF</h1>
      <div className="content">
        <div className={`${isVerified ? "verified" : ""}`}>
          <img
            src={BookCover}
            alt="Book Cover"
            className={`book-cover ${!isVerified ? "locked" : ""}`}
          />
        </div>
        <form onSubmit={handleEmailSubmit}>
          <p>Please enter the email you used for your purchase:</p>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
          {isLoading ? (
            <div className="spinner"></div>
          ) : (
            <button type="submit">Access The Program</button>
          )}
          {renderError()}
        </form>
      </div>
    </div>
  );
};

export default ConfirmationPage;
